import common from './common.json'
import game from './game.json'
import modals from './modals.json'
import notifications from './notifications.json'

// Section imports
import command from './sections/command.json'
import communication from './sections/communication.json'
import diplomacy from './sections/diplomacy.json'
import government from './sections/government.json'
import leaderboard from './sections/leaderboard.json'
import map from './sections/map.json'
import news from './sections/news.json'
import planets from './sections/planets.json'
import research from './sections/research.json'
import resources from './sections/resources.json'
import settings from './sections/settings.json'
import statistics from './sections/statistics.json'
import tutorial from './sections/tutorial.json'
import buildings from './sections/buildings.json'
import shipComponents from './sections/shipComponents.json'
import ores from './sections/ores.json'

export default {
  common,
  game,
  modals,
  notifications,
  command,
  communication,
  diplomacy,
  government,
  leaderboard,
  map,
  news,
  planets,
  research,
  resources,
  settings,
  statistics,
  tutorial,
  buildings,
  shipComponents,
  ores
}
